import {getGlobal} from '../helpers'
import {API, backend} from '../../index'
import ActiveRecord from './active_record/base'
import {date} from '@eitje/utils'

class Post extends ActiveRecord {
	static tableName = 'posts'
	static sort = item => {
		// posts from around 2021 are published but lack a published_at value, so use created_at as fallback for those
		const postDate = date(item.published_at || item.created_at)

		if (postDate.isValid()) {
			// newer posts have a larger Unix timestamp in milliseconds, and by making it negative they end up higher
			return -postDate.valueOf()
		}

		// posts with invalid or missing date are pushed to the bottom
		return Number.POSITIVE_INFINITY
	}

	sendReminder = async ({userId, all}) => {
		let res
		if (all) res = await backend.post('/posts/pns', {post_id: this.id, skipSuccessNotif: true, doNotLoad: true})
		if (userId) res = await backend.post('/posts/pn', {user_id: userId, post_id: this.id, skipSuccessNotif: true, doNotLoad: true})

		if (res.ok) await this.modelConfig?.sendReminderOnSuccess?.(res)

		return res
	}

	like = async () => {
		// TODO check which method we can use
		return await API.toggle('posts', {id: this.id, field: 'liking_users'})
	}

	createComment = async body => {
		return await API.create('comments', {post_id: this.id, body}, {localKind: 'posts'})
	}

	read = async () => {
		const meId = getGlobal('meId')
		if (!meId || this.reader_ids.includes(meId)) return
		backend.post('posts/read', {doNotLoad: true, ids: [this.id]})
		API.createLocal('posts', {
			id: this.id,
			reader_ids: [...this.reader_ids, meId],
		})
	}
}

export default Post
